module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"of":"av","brainDates":"hjernedates","play":"Spill"},"en":{"of":"of","brainDates":"Brain Dates","play":"Play"}}')
  delete Component.options._Ctor
}
